import { createGlobalStyle } from 'styled-components';
import { TABLET_WIDTH } from './Const';

const ScrollLock = createGlobalStyle`
  @media (max-width: ${TABLET_WIDTH}) {
    body {
      overflow: hidden;
    }
  }
`;

export default ScrollLock;
